import Navbar from "./Navbar";
import Footer from "./Footer";
import { Container, Row, Col, Button } from "react-bootstrap";
import { FaPhoneAlt, FaEnvelope } from "react-icons/fa";
import TestimonialSlider from "./TestimonialSlider";
import logo2 from "./assets/preview.jpg";
import logo3 from "./assets/preview.jpg";
import logo4 from "./assets/preview.jpg";
import logo5 from "./assets/preview.jpg";
import bgGif from "./assets/conatct.png";
import { useEffect } from "react";
import { useLocation } from "react-router-dom";
import { useState } from "react";

const Contact = () => {
  const location = useLocation();
useEffect(() => {
  if (location.state?.message) {
    setFormData(prev => ({ ...prev, message: location.state.message }));
  }
}, [location.state]);
  const logos = [logo2, logo3, logo4, logo5, logo2, logo4];
  const [formData, setFormData] = useState({
    firstName: "",
    lastName: "",
    company: "",
    email: "",
    phone: "",
    message: "",
  });
  const [errors, setErrors] = useState({});
  const [submitted, setSubmitted] = useState(false);

  // Validation — Message is optional
  const validate = () => {
    const newErrors = {};
    if (!formData.firstName.trim()) newErrors.firstName = "Required";
    if (!formData.lastName.trim()) newErrors.lastName = "Required";
    if (!formData.company.trim()) newErrors.company = "Required";
    if (!formData.email.trim()) newErrors.email = "Required";
    else if (!/\S+@\S+\.\S+/.test(formData.email))
      newErrors.email = "Invalid email";
    if (!formData.phone.trim()) newErrors.phone = "Required";
    // Message is optional — do not validate
    return newErrors;
  };

  const handleChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
    setErrors({ ...errors, [e.target.name]: "" });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    const validationErrors = validate();
    if (Object.keys(validationErrors).length > 0) {
      setErrors(validationErrors);
      return;
    }

    const formDataToSend = new FormData();
    formDataToSend.append("access_key", "557ba823-7a5f-4b8b-9b23-a389a9ad0833"); // Replace with your Web3Forms access key
    Object.entries(formData).forEach(([key, value]) => {
      formDataToSend.append(key, value);
    });

    const response = await fetch("https://api.web3forms.com/submit", {
      method: "POST",
      body: formDataToSend,
    });

    const result = await response.json();
    if (result.success) {
      setSubmitted(true);
      setFormData({
        firstName: "",
        lastName: "",
        company: "",
        email: "",
        phone: "",
        message: "",
      });
    }
  };

  return (
    <>
      <Navbar />
      <section
        style={{
          position: "relative",
          height: "120vh",
          width: "100%",
          overflow: "hidden",
        }}
      >
        <img
          src={bgGif}
          alt="background"
          style={{
            position: "absolute",
            top: 0,
            left: 0,
            width: "100%",
            height: "100%",
            objectFit: "cover",
            zIndex: -1,
          }}
        />

        <Container fluid className="py-5">
          <br />
          <br />
          <br />
          <Row>
            {/* Left Side */}
            <Col md={6} className="px-5">
              <h2 className="fw-bold text-dark">Get in Touch</h2>
              <p className="text-dark">
                Have questions? We’d love to hear from you. Send us a message and
                we’ll respond as soon as possible.
              </p>

              <div className="contact-info text-dark">
                <p>
                  <span className="icon-circle">
                    <FaPhoneAlt />
                  </span>
                +91 9861632429
                </p>
                <p>
                  <span className="icon-circle">
                    <FaEnvelope />
                  </span>
                  info@foxtroit.in
                </p>
              </div>

              <TestimonialSlider />

              {/* <p className="text-dark h4 pt-4 pb-4">Our Trusted Partners</p>
              <section
                style={{
                  display: "flex",
                  justifyContent: "space-around",
                  alignItems: "center",
                  flexWrap: "wrap",
                  borderRadius: "12px",
                }}
              >
                {logos.map((logo, index) => (
                  <div key={index} style={{ marginTop: "8px", width: "90px", height: "45px" }}>
                    <img
                      src={logo}
                      alt={`Company ${index + 1}`}
                      style={{
                        maxWidth: "100%",
                        maxHeight: "100%",
                        objectFit: "contain",
                        borderRadius: "50%",
                      }}
                    />
                     <br />
              <br />
              <br />
              <br />
                  </div>
                  
                ))}
              </section> */}
            </Col>


            {/* Right Side */}
            <Col md={6} className="px-5">
              <div
                className="p-4 shadow card"
                style={{
                  backgroundColor: "white",
                  borderRadius: "35px",
                  boxShadow: "0px 4px 15px #25024f",
                }}
              >
                {submitted ? (
                  <h3 className="text-center mb-2" style={{ color: "#d4197a" }}>
                    Thanks! We will get back soon.
                  </h3>
                ) : (
                  <h4 className="mb-2 fw-bold text-dark">Get In Touch</h4>
                )}

                <form className="underline-form text-dark" onSubmit={handleSubmit}>
                  <div className="row">
                    <div className="col-md-6 mb-1">
                      <label className="d-flex justify-content-between align-items-center">
                        <span>First Name *</span>
                        {errors.firstName && <small className="text-danger">{errors.firstName}</small>}
                      </label>
                      <input
                        type="text"
                        name="firstName"
                        value={formData.firstName}
                        onChange={handleChange}
                      />
                    </div>
                    <div className="col-md-6 mb-1">
                      <label className="d-flex justify-content-between align-items-center">
                        <span>Last Name *</span>
                        {errors.lastName && <small className="text-danger">{errors.lastName}</small>}
                      </label>
                      <input
                        type="text"
                        name="lastName"
                        value={formData.lastName}
                        onChange={handleChange}
                      />
                    </div>
                  </div>

                  <div className="row">
                    <div className="col-md-6 mb-1">
                      <label className="d-flex justify-content-between align-items-center">
                        <span>Company *</span>
                        {errors.company && <small className="text-danger">{errors.company}</small>}
                      </label>
                      <input
                        type="text"
                        name="company"
                        value={formData.company}
                        onChange={handleChange}
                      />
                    </div>
                    <div className="col-md-6 mb-1">
                      <label className="d-flex justify-content-between align-items-center">
                        <span>Email *</span>
                        {errors.email && <small className="text-danger">{errors.email}</small>}
                      </label>
                      <input
                        type="email"
                        name="email"
                        value={formData.email}
                        onChange={handleChange}
                      />
                    </div>
                  </div>

                  <div className="row">
                    <div className="col-12 mb-1">
                      <label className="d-flex justify-content-between align-items-center">
                        <span>Phone *</span>
                        {errors.phone && <small className="text-danger">{errors.phone}</small>}
                      </label>
                      <input
                        type="text"
                        name="phone"
                        value={formData.phone}
                        onChange={handleChange}
                      />
                    </div>
                  </div>

                  <div className="row">
                    <div className="col-12 mb-1">
                      <label className="d-flex justify-content-between align-items-center">
                        <span>Message</span>
                        {errors.message && <small className="text-danger">{errors.message}</small>}
                      </label>
                      <textarea
                        name="message"
                        rows="2"
                        value={formData.message}
                        onChange={handleChange}
                      ></textarea>
                    </div>
                  </div>

                  <div className="d-flex justify-content-center align-items-center">
                    <Button
                      style={{
                        backgroundColor: "black",
                        border: "none",
                        borderRadius: "8px",
                        boxShadow: "0px 4px 12px rgba(0,0,0,0.5)",
                        padding: "10px 20px",
                      }}
                      type="submit"
                    >
                      Send Message
                    </Button>
                  </div>
                </form>
              </div>
            </Col>
          </Row>

          <style>{`
            .underline-form {
              display: flex;
              flex-direction: column;
              gap: 1.5rem;
              color: black;
            }

            .underline-form label {
              margin-bottom: 4px;
              font-size: 15px;
              font-weight: 500;
            }

            .underline-form input,
            .underline-form textarea {
              border: none;
              border-bottom: 1px solid black;
              background: transparent;
              outline: none;
              padding: 6px 0;
              font-size: 16px;
              width: 100%;
              color: black;
              margin-bottom: 4px;
            }

            .underline-form input:focus,
            .underline-form textarea:focus {
              border-bottom: 2px solid #d4197a;
            }

            .contact-info p {
              display: flex;
              align-items: center;
              font-size: 16px;
              margin-bottom: 12px;
              gap: 10px;
              color: black;
            }

            .icon-circle {
              color: #25024f;
              border-radius: 50%;
              display: flex;
              align-items: center;
              justify-content: center;
              width: 36px;
              height: 36px;
              font-size: 16px;
            }
          `}</style>
        </Container>
      </section>
      <Footer />
    </>
  );
};

export default Contact;
